import Vue from 'vue'
import Message from './tips.vue'

Vue.prototype.$my_message = {
  component: null,
  init: function () {
    var message = Vue.extend(Message)
    this.component = new message().$mount()
  },
  show: function (options, e) {
    this.init()
    try {
      document.body.removeChild(document.getElementsByClassName('tips-wrapp')[0])
    } catch{ }
    document.body.appendChild(this.component.$el)
    this.component.show(options, e)
  },

  hide: function () {
    this.component.hide()
  }
}


Message.install = function (Vue) {
  Vue.component(Message.name, Message);
}
export default Message